import { env } from "./constants";
import { createFeatureFlags, getMode } from "./feature-flag";
import { getBaseUrl } from "./get-base-url";

/**
 * セッション情報プロバイダーの型定義
 */
export interface SessionProvider {
  getSession: () => { organizationId: string } | null;
}

/**
 * 動的にセッション情報を取得するための関数
 * auth storeが利用可能になったときに設定される
 */
let sessionProvider: SessionProvider | null = null;

/**
 * セッション情報プロバイダーを設定する
 * auth storeの初期化後に呼び出される
 */
export const setSessionProvider = (provider: SessionProvider | null) => {
  sessionProvider = provider;
};

const featureFlags = createFeatureFlags({
  getSession: () => {
    // auth storeが設定されていない場合はnullを返す
    if (!sessionProvider) {
      return null;
    }

    try {
      return sessionProvider.getSession();
    } catch (error) {
      console.warn("Failed to get session for feature flags:", error);
      return null;
    }
  },
  getMode: () => getMode(),
});

export { env, featureFlags, getBaseUrl, getMode };
